var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 10.647a.416.416 0 11-.59.588.416.416 0 01.59-.588",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 10.842v0a3.587 3.587 0 01-1.29 2.757l-1.286 1.07a3.592 3.592 0 00-1.106 1.62l-.238.713-.237-.712a3.595 3.595 0 00-1.107-1.62L9.371 13.6a3.583 3.583 0 01-1.29-2.755v.02A3.859 3.859 0 0112 6.999a3.859 3.859 0 013.92 3.865",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.002 21.004H6.998a4.002 4.002 0 01-4.002-4.002V6.998a4.002 4.002 0 014.002-4.002h10.004a4.002 4.002 0 014.002 4.002v10.004a4.002 4.002 0 01-4.002 4.002z",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLocation;